module.exports = __webpack_public_path__ + "static/sport/slide1.fed6f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/slide1.png
// module id = 3twk
// module chunks = 0